(function () {
  'use strict';

  function removeTrailingZeroDecimals(value) {
    if (typeof value !== 'string' || value.length === 0) return value;

    return value
      .replace(/(\d{1,3}(?:[.,]\d{3})+)([.,]00)\b/g, '$1')
      .replace(/(\d+)([.,]00)\b/g, '$1');
  }

  function normalizeWhatsappProductSettings() {
    var settings = window.whatsappProductSettings;
    if (!settings || typeof settings.productPrice !== 'string') return;

    settings.productPrice = removeTrailingZeroDecimals(settings.productPrice);
  }

  function normalizeWhatsappPriceNodes(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll(
      '.whatsapp-product-button-container .glc-money, .whatsapp-product-button-container [data-product-price], .whatsapp-product-button-container .product-price'
    );

    nodes.forEach(function (node) {
      node.textContent = removeTrailingZeroDecimals(node.textContent || '');
    });
  }

  function normalizeProductPriceNodes(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.price-item--regular, .price-item--sale, .glc-money');

    nodes.forEach(function (node) {
      node.textContent = removeTrailingZeroDecimals(node.textContent || '');
    });
  }

  function unhideElement(node) {
    if (!node || !(node instanceof Element) || !node.style) return;
    node.style.removeProperty('opacity');
    node.style.removeProperty('visibility');
    node.style.removeProperty('pointer-events');
    node.style.removeProperty('display');
  }

  function unhideWhatsappProductButton(root) {
    var scope = root || document;
    if (
      scope instanceof Element &&
      (scope.matches(".shopify-app-block[id*='whatflow_chat_automation_whatsapp_product_button']") ||
        scope.matches('.whatsapp-product-button-container') ||
        scope.matches('.whatsapp-product-btn') ||
        scope.matches("[id*='whatsapp-product']"))
    ) {
      unhideElement(scope);
    }

    var nodes = scope.querySelectorAll(
      ".shopify-app-block[id*='whatflow_chat_automation_whatsapp_product_button'], .whatsapp-product-button-container, .whatsapp-product-btn, [id*='whatsapp-product']"
    );

    nodes.forEach(function (node) {
      unhideElement(node);
      if (node.querySelectorAll) {
        node.querySelectorAll('*').forEach(function (child) {
          unhideElement(child);
        });
      }
    });
  }

  function wrapOpenWhatsappFunction() {
    var original = window.openWhatsAppProduct;
    if (typeof original !== 'function' || original.__mxPriceNormalized) return;

    var wrapped = function () {
      normalizeWhatsappProductSettings();
      normalizeWhatsappPriceNodes();
      return original.apply(this, arguments);
    };

    wrapped.__mxPriceNormalized = true;
    window.openWhatsAppProduct = wrapped;
  }

  function runNormalization(root) {
    unhideWhatsappProductButton(root);
    normalizeWhatsappProductSettings();
    normalizeWhatsappPriceNodes(root);
    normalizeProductPriceNodes(root);
    wrapOpenWhatsappFunction();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;

        if (
          node.matches('.whatsapp-product-button-container') ||
          node.querySelector('.whatsapp-product-button-container') ||
          node.matches('.price-item--regular, .price-item--sale, .glc-money') ||
          node.querySelector('.price-item--regular, .price-item--sale, .glc-money')
        ) {
          runNormalization(node);
        }
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runNormalization();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    runNormalization();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  var attempts = 0;
  var intervalId = window.setInterval(function () {
    runNormalization();
    attempts += 1;
    if (attempts >= 15) {
      window.clearInterval(intervalId);
    }
  }, 1000);
})();
